import { v4 as uuidv4 } from 'uuid'
import { apiCall, apiPost, apiGet, apiBatch } from './apiClient'

function delayExecution(callback, delay) {
    setTimeout(callback, delay)
}

export const delay = (ms) => new Promise((res) => setTimeout(res, ms))

const apiBaseUrl = process.env.REACT_APP_API_URL_BASE

//   const msalConfig = {
//       auth: {
//           clientId: '70f0ff96-0505-4270-92df-76babba0f3d7'
//       }
//   };

//   const msalInstance = new PublicClientApplication(msalConfig);

//   var request = {
//     scopes: ["api://10db4c25-3f20-4719-b421-bb23cce19cd7/.default"]
//   };

//   let tokenResponse;
//   let objectId

//   const signInUser = async () => {
//     await msalInstance.initialize();
//     console.log('signing in',msalInstance)
//     try {
//       tokenResponse = await msalInstance.acquireTokenSilent(request);
//       if (!tokenResponse || !tokenResponse.accessToken || tokenResponse.accessToken.split('.').length !== 3) {
//         throw new Error('Invalid access token');
//       }
//       objectId = tokenResponse.account.idTokenClaims.oid;
//       console.log('User objectId:', objectId);
//     } catch (error) {
//       console.log('error not in interaction',error)
//       if (error) {
//         console.error('error in sign in', error)
//         // fallback to interaction when silent call fails
//         tokenResponse = await msalInstance.acquireTokenPopup(request);
//         if (!tokenResponse || !tokenResponse.accessToken || tokenResponse.accessToken.split('.').length !== 3) {
//           throw new Error('Invalid access token');
//         }
//         objectId = tokenResponse.account.idTokenClaims.oid;
//         console.log('User objectId: 2', objectId);
//       }
//       // handle other errors
//     }
//   };

/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */
/*                                                                    MRT API Calls                                                                     */
/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */

/* -------------------------------------------------------------------------- */
/*                              Propel Requests                               */
/* -------------------------------------------------------------------------- */

export const updateRoles = async (
    jsonPayload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/auth/propelauth/update-roles',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const inviteUserToOrganization = async (
    jsonPayload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/auth/propelauth/invite-user-to-organization',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const listUsersInOrganization = async (
    orgId,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/auth/propelauth/list-users-in-organization',
        method: 'POST',
        body: {},
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const addUserToTemplate = async (
    jsonPayload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/auth/propelauth/add-user-to-template',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const addUserToDocumentSet = async (
    jsonPayload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/auth/propelauth/add-user-to-document-set',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* -------------------------------------------------------------------------- */
/*                              General API Calls                             */
/* -------------------------------------------------------------------------- */

// Key must be of form "{org_id}/{file_path}"
export const generatePresignedUrl = async (key, orgAccessToken) => {
    return await apiPost(
        'generate-presigned-url', 
        { 
            key: key 
        }, 
        { 
            responseType: 'json', 
            orgAccessToken: orgAccessToken 
        }
    )
}
/* -------------------------------------------------------------------------- */
/*                               Edit Template                                */
/* -------------------------------------------------------------------------- */

export const listAllMRTTemplates = async (orgAccessToken) => {
    const result = await apiCall({
        endpoint: 'list-all-mrt-templates',
        orgAccessToken,
        responseType: 'json'
    })
    return result.templates
}

export const getOneMRTTemplate = async (template_name, orgAccessToken) => {
    return await apiCall({
        endpoint: 'get-one-mrt-template',
        method: 'POST',
        body: {
            template_id: template_name,
        },
        orgAccessToken,
        responseType: 'json'
    })
}

export const updateGenericMRT = async (
    orgAccessToken,
    jsonPayload
) => {
    return await apiCall({
        endpoint: 'update-generic-mrt',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken,
        responseType: 'json'
    })
}

export const upsertExampleToSection = async (
    orgAccessToken,
    jsonPayload
) => {
    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)


    const raw = JSON.stringify({
        example: jsonPayload.example,
        section_id: jsonPayload.section_id
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/upsert-example-to-section`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source chunk from chunk id\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        return result
    } catch (error) {
        console.error('Error getting source chunk from chunk id:', error)

        throw error
    }
}

export const updateTemplateName = async (
    orgAccessToken,
    jsonPayload
) => {
    return await apiCall({
        endpoint: 'update-template-name',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const duplicateTemplate = async (template_id, orgAccessToken) => {
    const result = await apiCall({
        endpoint: 'duplicate-mrt-template',
        method: 'POST',
        body: { template_id: template_id },
        orgAccessToken,
        responseType: 'json'
    })
    return result.template_id
}

export const duplicateDocument = async (document_id, orgAccessToken) => {
    const result = await apiCall({
        endpoint: 'duplicate-document',
        method: 'POST',
        body: { document_id: document_id },
        orgAccessToken,
        responseType: 'json'
    })
    return result.document_id
}

/* -------------------------------------------------------------------------- */
/*                              Create Template                               */
/* -------------------------------------------------------------------------- */

export const getDocumentTypesForOrganization = async (    
    orgAccessToken,
    payload
) => {
    return await apiCall({
        endpoint: 'get-document-types-for-organization',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const ingestTemplate = async (
    templateName,
    documentPath,
    orgAccessToken,
    setLoading
) => {
    const result = await apiCall({
        endpoint: 'ingest-template',
        method: 'POST',
        body: {
            template_name: templateName,
            document_path: documentPath,
            clean_formatting: false
        },
        orgAccessToken,
        setLoading,
        responseType: 'text'
    })
    return result
}

export const ingestSourceDocuments = async (
    source_documents,
    doc_set_key,
    orgAccessToken,
    setLoading
) => {
    return await apiPost(
        'ingest-source-documents', 
        {
            source_documents: source_documents,
            azure_index: '',
            use_mistral_ocr: false,
            doc_set_key: doc_set_key
        }, 
        {
            orgAccessToken,
            setLoading
        }
    )
}

export const analyzeExampleDocument = async (
    document_path,
    azure_index,
    doc_set_key,
    orgAccessToken,
    setLoading
) => {
    return await apiCall({
        endpoint: 'analyze-example-document',
        method: 'POST',
        body: {
            document_path: document_path,
            azure_index: azure_index,
            doc_set_key: doc_set_key
        },
        orgAccessToken,
        setLoading,
        responseType: 'json'
    })
}


export const getMRTOutline = async (
    setLoading,
    setError,
    orgAccessToken,
    jsonPayload
) => {
    setLoading(true)

    const result = jsonPayload

    setLoading(false)
    return result
}

export const createGenericMRTOutlineAsync = async (
    orgAccessToken,
    jsonPayload
) => {
    return await apiCall({
        endpoint: 'create-generic-mrt-async',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const deleteTemplate = async (
    orgAccessToken,
    jsonPayload
) => {
    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)


    const raw = JSON.stringify({
        document_nickname: jsonPayload.document_nickname
    })

    const requestOptions = {
        method: 'DELETE',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/delete-template`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error deleting template\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        return result
    } catch (error) {
        console.error('Error deleting template:', error)

        throw error
    }
}

export const ingestTabulatedSummaryExamples = async (
    orgAccessToken,
    payload
) => {
    return await apiCall({
        endpoint: 'ingest-tabulated-summary-examples',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */
/*                                                                  Document Page                                                                       */
/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */

export const getSectionNameFromSelectedText = async (
    documentId,
    selectedText,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'get-section-name-from-selected-text',
        method: 'POST',
        body: {
            document_id: documentId,
            selected_text: selectedText
        },
        orgAccessToken: orgAccessToken,        
        responseType: 'json'
    })
}

export const getDocumentFromId = async (
    document_id,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'get-document-from-id',
        method: 'POST',
        body: {
            document_id: document_id
        },
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

// Result is an array of objects with the following properties:
//
// {
//     "url": The url of the source chunk
//     "chunk_id": The id used to get the source chunk info,
//     "snippet": The chunk of text stored in the source chunk
//     "page_number": The page number of the document where the source chunk originates
// }
//
export const getSourceChunkInfo = async (
    setLoading,
    chunk_id,
    orgAccessToken
) => {
    setLoading(true)

    const header = new Headers()
    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        chunk_id: chunk_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-source-chunk-info`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source chunk info\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()
        setLoading(false)
        return result
    } catch (error) {
        console.error('Error getting source chunk info:', error)
        setLoading(false)
        throw error
    }
}

export const getChunkFromId = async (
    setLoading,
    setError,
    chunk_id,
    orgAccessToken
) => {
    setLoading(true)

    const header = new Headers()
    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        chunk_id: chunk_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-chunk-from-id`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source chunk from chunk id\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        setLoading(false)

        return result
    } catch (error) {
        console.error('Error getting source chunk from chunk id:', error)

        setLoading(false)
        setError(false)
        
        throw error
    }
}

export const getChunksFromIds = async (
    setLoading,
    setError,
    chunk_ids,
    orgAccessToken
) => {
    setLoading(true)

    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        chunk_ids: chunk_ids,
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-chunks-from-ids`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source chunk from chunk id\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        setLoading(false)
        
        return result
    } catch (error) {
        console.error('Error getting source chunk from chunk id:', error)
        setLoading(false)
        setError(true)
        throw error
    }
}

// {
//     "name": "BHV IB Generic MRT",
//     "description": "IB For Biohaven",
//     "document_type": "IB",
//     "template_filename": "input/BHV-1600/Templates/IB Model Document (V2).pdf",
//     "example_filenames": [
//         "input/BHV-1600/Examples/bhv1300-ib-v1.pdf"
//     ],
//     "cache_version": "1.0.14"
// }
export const getSourceDataReferences = async (
    setLoading,
    setError,
    document_id,
    orgAccessToken
) => {
    setLoading(true)

    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_ids: document_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-documents-from-ids`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source data references\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        setLoading(false)

        return result
    } catch (error) {
        console.error('Error getting source data references:', error)

        setLoading(false)
        setError(true)

        throw error
    }
}

export const getMRTTables = async (
    setLoading,
    setError,
    mrtTableIds,
    orgAccessToken
) => {
    setLoading(true)

    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        mrt_table_ids: mrtTableIds,
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }
    
    try {
        const response = await fetch(
            `${apiBaseUrl}/get-mrt-tables-from-ids`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting mrt tables\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        setLoading(false)

        return result
    } catch (error) {
        console.error('Error getting mrt tables:', error)

        setLoading(false)
        setError(true)

        throw error
    }
}

// Response is an object with the following properties:
//
// {
//     "section_name": Section to be regenerated
//     "content": AI generated content
// }
//
export const recreateSelection = async (
    setLoading,
    orgAccessToken,
    documentId,
    tflRunId,
    sourceIndex,
    selectedText,
    userModifications,
    // sectionName,
    // description,
    folderName = 'internal',
) => {
    setLoading(true)

    const header = new Headers()
    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: documentId,
        tfl_run_id: tflRunId,
        source_index: sourceIndex,
        selected_text: selectedText,
        // section_name: sectionName,
        // description: description,
        user_modifications: userModifications,
        folder_name: 'internal,',
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/documents/recreate-selection`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error regenerating selection\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()
        setLoading(false)
        return result
    } catch (error) {
        console.error('Error regenerating selection:', error)
        setLoading(false)
        throw error
    }
}

// Response is an object with the following properties:
//
// {
//     "tfl_url": The the url of the TFL file
// }
//

export const getSourceTFLInfo = async (
    setLoading,
    orgAccessToken,
    tfl_source_file_name
) => {
    setLoading(true)

    const header = new Headers()
    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        tfl_name: tfl_source_file_name
    })

    const requestOptions = {
        method: 'POST',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-source-tfl-info`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error getting source TFL info\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()
        setLoading(false)
        return result
    } catch (error) {
        console.error('Error getting source TFL info:', error)
        setLoading(false)
        throw error
    }
}

export const getOutlineFromDocumentID = async (
    document_id,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'get-outline-from-document-id',
        method: 'POST',
        body: {
            document_id: document_id
        },
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const updateDocumentName = async (
    orgAccessToken,
    jsonPayload
) => {
    return await apiCall({
        endpoint: 'update-document-name',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const deleteDocument = async (
    orgAccessToken,
    jsonPayload
) => {
    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)


    const raw = JSON.stringify({
        document_id: jsonPayload.document_id
    })

    const requestOptions = {
        method: 'DELETE',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/delete-document`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error deleting template\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        return result
    } catch (error) {
        console.error('Error deleting template:', error)

        throw error
    }
}

export const updateDocumentStatus = async (
    document_id,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'update-document-status',
        method: 'POST',
        body: {
            document_id: document_id
        },
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* -------------------------------------------------------------------------- */
/*                              Create Document                               */
/* -------------------------------------------------------------------------- */

export const extractAndClassifyDocuments = async (
    setError,
    setProgress,
    payloads,
    orgAccessToken
) => {
    const calls = payloads.map(payload => {  
        return {
            endpoint: 'extract-and-classify-document',
            method: 'POST',
            body: {
                file_paths: payload.file_paths,
                document_set_key: payload.document_set_key,
            },
            orgAccessToken: orgAccessToken,
            responseType: 'json'
        }
    })
    try {
        const extractedClassificationResults = await apiBatch(calls, {
            setProgress,
            setError
        })
        return extractedClassificationResults
    } catch (error) {
        console.error('Error extracting and classifying documents:', error)
        setError(true)
        throw error
    }
}

export const batchIngestDocuments = async (
    setError,
    setProgress,
    payloads,
    orgAccessToken
) => {
    const calls = payloads.map(payload => {
        console.log('payload:', payload)
        return {
            endpoint: 'ingest-documents',
            method: 'POST',
            body: payload,
            orgAccessToken: orgAccessToken,
            responseType: 'json'
        }
    })
    try {
        const ingestionResults = await apiBatch(calls, {
            setProgress,
            setError
        })
        return ingestionResults
    } catch (error) {
        console.error('Error ingesting documents:', error)
        setError(true)
        throw error
    }
}

export const ingestDocuments = async (
    setProgress,
    progress,
    source_documents,
    document_set_key,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        source_documents: source_documents,
        document_set_key: document_set_key,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/ingest-documents`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error ingesting documents\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        const newProgress = progress + 1
        setProgress(newProgress)

        return result
    } catch (error) {
        console.error('Error ingesting documents:', error)
        setProgress(0)
        throw error
    }
}

export const concatenateTFLFiles = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'concatenate-tfl-files',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const fullBatchIngestionAsync = async (
    payloads,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'full-batch-ingestion-async',
        method: 'POST',
        body: payloads,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const ingestAndGenerateDocument = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'ingest-and-generate-document-async',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const extractIngestAndOrchestrateMRT = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'extract-ingest-and-orchestrate-mrt',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const pkTabulatedSummaryGenerationAsync = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'pk-tabulated-summary-generation-async',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const txTabulatedSummaryGenerationAsync = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'tx-tabulated-summary-generation-async',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const pharmTabulatedSummaryGenerationAsync = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'pharm-tabulated-summary-generation-async',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* -------------------------------------------------------------------------- */
/*                              Sections Tab                                  */
/* -------------------------------------------------------------------------- */

export const getSourcesForSelectedText = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'get-sources-for-selected-text',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* -------------------------------------------------------------------------- */
/*                              Document Tab                                  */
/* -------------------------------------------------------------------------- */

export const getDocumentTypeFromFilePath = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'get-document-type-from-file-path',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const extractClassifyAndIngestCelery = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'extract-classify-and-ingest-celery',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* ---------------------------------------------------------------- */
/*                       Table Assignment                           */
/* ---------------------------------------------------------------- */


export const listAllMRTTablesFromDocumentPathAndConnectorId = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'list-all-mrt-tables-from-document-path-and-connector-id',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const documentsRegenerateV1 = async (
    payload,
    orgAccessToken
) => {
    return await apiCall({
        endpoint: 'api/v1/documents/regenerate',
        method: 'POST',
        body: payload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */
/*                                                                    String Hashing                                                                    */
/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */

export const sha256 = async (message) => {
    const encoder = new TextEncoder()
    const data = encoder.encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('')
    return hashHex
}


/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */
/*                                                                    Past API Calls                                                                    */
/* ---------------------------------------------------------------------------------------------------------------------------------------------------- */

/* -------------------------------------------------------------------------- */
/*                              Upload Files                                  */
/* -------------------------------------------------------------------------- */

export const uploadMultipleFilesUpdated = async (
    setLoading,
    files,
    filesContent,
    setError,
    container,
    orgAccessToken
) => {
    setLoading(true)

    try {
        const uploadPromises = files.map(async (file, i) => {
            const formData = new FormData()
            formData.append('file_name', file.name)
            formData.append('file_content', new Blob([filesContent[i]]))

            var headers = new Headers()
            headers.append(
                'Authorization',
                'Bearer ' + orgAccessToken.accessToken
            )
            headers.append('container', container)

            const requestOptions = {
                method: 'POST',
                body: formData,
                headers: headers,
            }

            const response = await fetch(
                `${apiBaseUrl}/upload-multiple-files`,
                requestOptions
            )

            if (!response.ok) {
                throw new Error(
                    `Error uploading file ${file.name}: ${response.statusText}`
                )
            }

            return await response.text()
        })

        await Promise.all(uploadPromises)
    } catch (error) {
        console.error('Error uploading files:', error)
        setError(true)
    }
}

export const processInputDocument = async (fileName, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_documents: [fileName],
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/processInputDocument`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error('Failed to process input document')
        }
        return await response.json()
    } catch (error) {
        console.error('Error processing input document:', error)
        throw error
    }
}

export const getCSVColumns = async (
    fileName,
    orgAccessToken,
    blob_container
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        csv_key: blob_container + '/' + fileName,
        // blob_container: blob_container,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-csv-columns`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        const columns = data['csv_columns']
        return columns
    } catch (error) {
        console.error('Error getting CSV columns:', error)
        throw error
    }
}

export const preprocessUploadedCSV = async (
    csvKey,
    blobContainer,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        csv_key: blobContainer + '/' + csvKey,
        // blob_container: blobContainer,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/preprocess-uploaded-csv`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = response
        return result
    } catch (error) {
        console.error('Error preprocessing CSV:', error)
        throw error
    }
}

export const addTabularDataToDoc = async (tableData, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(tableData),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/add-tabular-data-to-doc`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        // NOTE: no JSON response; do NOT parse expecting one.
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error adding tabular data to document:', error)
        throw error
    }
}

export const getTableTitlesInSection = async (payload, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-table-titles-in-section`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const tableTitles = result['table_titles_in_section']
        return tableTitles
    } catch (error) {
        console.error('Error getting table titles:', error)
        throw error
    }
}

export const updateTabularDataToDoc = async (payload, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/update-tabular-data-to-doc`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error updating tabular data in document:', error)
        throw error
    }
}

/* -------------------------------------------------------------------------- */
/*                           Generate Document Calls                          */
/* -------------------------------------------------------------------------- */

export const generateOutline = async (
    setLoading,
    setError,
    files,
    outline,
    document_name,
    product_name,
    document_type,
    orgAccessToken
) => {
    setLoading(true)
    console.log('files', files)
    console.log('outline', outline)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_path: files,
        input_container: 'input',
        outline: outline,
        product_name: product_name,
        output_doc_type: document_type,
        output_doc_name: document_name,
        example: '',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    await fetch(`${apiBaseUrl}/api/generateOutline`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => {
            setError(true)
            console.error(error)
        })
}

export const generateBoth = async (
    setLoading,
    setError,
    document_name,
    product_name,
    document_type,
    orgAccessToken
) => {
    setLoading(true)
    console.log('document_name', document_name)
    console.log('product_name', product_name)
    console.log('document_type', document_type)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_name: document_name,
        product_name: product_name,
        document_type: document_type,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/generateBoth`, 
            requestOptions
        )
        if (!response.ok) {
            throw new Error(
                `Error generating both: ${response.statusText}`
            )
        }
        const result =  await response.text()
        console.log(result)
        setLoading(false)
        return response
    } catch (error) {
        console.error(error)
        setError(true)
        setLoading(false)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const createINDModule2Section = async (
    setLoading,
    setError,
    files,
    document_name,
    product_name,
    orgAccessToken
) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_path: files,
        conditions: '',
        external_sources: [''],
        product_name: product_name,
        input_container: 'intermediate',
        randomID: 'testnamespace7',
        pc_index_name: 'biohaven',
        source: '',
        query: '',
        doc_name: document_name,
        output_doc_name: document_name,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/createINDModule2Section`,
            requestOptions
        )
        const result = await response.text()
        setLoading(false)
        return result // Return the result here
    } catch (error) {
        console.error(error)
        setError(true)
        setLoading(false)
        throw error // Rethrow the error after logging and setting error state
    }
}

/* -------------------------------------------------------------------------- */
/*                             Document Sets Calls                            */
/* -------------------------------------------------------------------------- */

export const getDocumentSets = async (setLoading, setError, orgAccessToken) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-all-document-sets`,
            requestOptions
        )
        const result = await response.json()
        const documentSets = result['document_sets']
        setLoading(false)
        return documentSets // Return the result here
    } catch (error) {
        console.error(error)
        // setError(true);
        setLoading(false)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const getOneDocumentSet = async (
    setLoading,
    setError,
    id,
    orgAccessToken
) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('id in getOneDocumentSet', id)

    const raw = JSON.stringify({
        document_set_name: id,
        folder_names: ['internal', 'output'],
    })

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
        body: raw,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-one-document-set`,
            requestOptions
        )
        const result = await response.json()
        
        setLoading(false)
        return result // Return the result here
    } catch (error) {
        console.error(error)
        setError(true)
        setLoading(false)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const updateDocumentSetName = async (
    orgAccessToken,
    jsonPayload
) => {
    return await apiCall({
        endpoint: 'update-document-set-name',
        method: 'POST',
        body: jsonPayload,
        orgAccessToken: orgAccessToken,
        responseType: 'json'
    })
}

export const deleteDocumentSet = async (
    orgAccessToken,
    jsonPayload
) => {
    const header = new Headers()

    header.append('Content-Type', 'application/json')
    header.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)


    const raw = JSON.stringify({
        document_nickname: jsonPayload.document_nickname
    })

    const requestOptions = {
        method: 'DELETE',
        headers: header,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/delete-document-set`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error deleting template\n ${response.status}: ${response.statusText}`)
        }

        const result = await response.json()

        return result
    } catch (error) {
        console.error('Error deleting template:', error)

        throw error
    }
}

/* -------------------------------------------------------------------------- */
/*                               String Utils                                 */
/* -------------------------------------------------------------------------- */

export const removeOrgId = (filename, orgId) => {
    return filename.replace(`${orgId}/`, '')
}

export const formatFilename = (filename) => {
    return filename.replace(/(.+?\/)/g, '')
}

export const formatInputFiles = (inputFiles) => {
    return inputFiles
        .map((file) => formatFilename(file.name))
        .join('\n')
}

export const removeFileExtension = async (filename) => {
    const commonExtensions = [
        '.csv',
        '.xlsx',
        '.docx',
        '.pdf',
        '.rtf',
        '.txt',
        '.doc',
        '.xls',
        '.ppt',
        '.pptx',
        '.odt',
        '.ods',
        '.odp',
    ]
    let cleanedFilename = filename

    for (const ext of commonExtensions) {
        if (cleanedFilename.toLowerCase().endsWith(ext)) {
            cleanedFilename = cleanedFilename.slice(0, -ext.length)
            break // Stop after removing one extension
        }
    }

    return cleanedFilename
}

export const syncRemoveFileExtension = (filename) => {
    const commonExtensions = [
        '.csv',
        '.xlsx',
        '.docx',
        '.pdf',
        '.rtf',
        '.txt',
        '.doc',
        '.xls',
        '.ppt',
        '.pptx',
        '.odt',
        '.ods',
        '.odp',
    ]
    let cleanedFilename = filename

    for (const ext of commonExtensions) {
        if (cleanedFilename.toLowerCase().endsWith(ext)) {
            cleanedFilename = cleanedFilename.slice(0, -ext.length)
            break // Stop after removing one extension
        }
    }

    return cleanedFilename
}

export const getIDFromName = async (documentName, orgAccessToken) => {
    const cleanedDocumentName = await removeFileExtension(documentName)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_name: cleanedDocumentName,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/getIDFromName`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        return result.id // Assuming the API returns an object with an 'id' field
    } catch (error) {
        console.error('Error getting document ID:', error)
        throw error
    }
}

/* -------------------------------------------------------------------------- */
/*                              Document Calls                                */
/* -------------------------------------------------------------------------- */

export const getOneDocument = async (
    setLoading,
    setError,
    id,
    orgAccessToken
) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('id in getOneDocument', id)

    const raw = JSON.stringify({
        document_id: id,
        folder_names: ['internal', 'output'],
    })

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
        body: raw,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-one-document`,
            requestOptions
        )
        const result = await response.json()
        setLoading(false)
        return result // Return the result here
    } catch (error) {
        console.error(error)
        setError(true)
        setLoading(false)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const saveFile = async (id, fileContent, orgAccessToken) => {
    // Create a new URL object
    console.log('id', id)
    // // Split the filename on '.docx', take the first part, and add '.docx' back to it
    // fileName = fileName.split('.docx')[0] + '.docx';

    // console.log('newFilename',fileName); // Outputs: 'b66ec74293ad4f1587a8110a6d006317-device-protocol-template-output.docx'

    console.log('filesContent', fileContent)

    try {
        // Use Promise.all to upload multiple files concurrently

        // console.log('file here', fileName)
        const formData = new FormData()
        formData.append('id', id)
        formData.append('file_content', fileContent)

        var headers = new Headers()
        headers.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)
        // headers.append("Authorization", "Bearer " + tokenResponse.accessToken);
        // headers.append("X-MS-CLIENT-PRINCIPAL-ID", '050e6292-662f-4b0f-9a89-4b0beca8bed6')

        const requestOptions = {
            method: 'POST',
            body: formData,
            headers: headers,
        }

        const response = await fetch(
            `${apiBaseUrl}/api/saveFile`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error uploading file: ${response.statusText}`)
        }

        const result = await response.text()
        console.log('file name:', result)
        createOutputVectorstore(id, 'output', orgAccessToken)

        // Handle the response from the Azure Function if needed
    } catch (error) {
        console.error('Error uploading files:', error)
    }
}

export const extractAndStoreMultiple = async (
    setLoading,
    setError,
    files,
    inputContainer,
    orgAccessToken
) => {
    setLoading(true)

    console.log('extracting and storing')

    var myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)
    // myHeaders.append("X-MS-CLIENT-PRINCIPAL-ID", "050e6292-662f-4b0f-9a89-4b0beca8bed6" );
    // myHeaders.append("Authorization", "Bearer " + tokenResponse.accessToken);

    var raw = JSON.stringify({
        input_path: files,
        // "pc_index_name": indexName,
        input_container: inputContainer,
        doc_type: 'testing',
        // "randomID": namespace
    })

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    await fetch(`${apiBaseUrl}/api/extractAndStoreMultiple`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
            console.log(result)
            setLoading(false)
        })
        .catch((error) => {
            console.log('error', error)
            setError(true)
            setLoading(false)
        })
}

export const extractAndStoreMultipleMongo = async (
    setLoading,
    setError,
    files,
    inputContainer,
    orgAccessToken
) => {
    setLoading(true)

    console.log('extracting and storing in MongoDB')

    var myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    var raw = JSON.stringify({
        input_path: files,
        folder_name: inputContainer,
        collection_name: 'chunks',
        document_type: 'testing',
    })

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/extract-and-store-multiple-mongo`,
            requestOptions
        )
        const result = await response.text()
        console.log(result)
    } catch (error) {
        console.log('error', error)
        setError(true)
    } finally {
        setLoading(false)
    }
}


export const getSources = async (
    setLoading,
    setError,
    document_id,
    section_text,
    section_name,
    orgAccessToken
) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
        section_name: '',
        section_text: section_text,
        external_search: false,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-sources`,
            requestOptions
        )
        const result = await response.json() // Await the parsing of the JSON
        console.log(result)
        const sources = result['sources']
        return sources // Return the parsed JSON
    } catch (error) {
        console.error(error)
        setError(error) // Assuming setError is used to handle errors
        return null // Return null or an appropriate value indicating failure
    }
}

export const findInconsistencies = async (
    document_id,
    section_name,
    section_text,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
        section_name: '',
        section_text: section_text,
        external_search: false,
        // input_container: 'output',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/find-inconsistencies`,
            requestOptions
        )
        const result = await response.json() // Await the parsing of the JSON
        console.log(result)
        return result // Return the parsed JSON
    } catch (error) {
        console.error(error)
        return null // Return null or an appropriate value indicating failure
    }
}

export const chatWithDoc = async (
    question,
    document_id,
    chatHistory,
    folder_name,
    orgAccessToken
) => {
    // console.log('chatting with', protocolFile)
    // const url_part = protocolFile.replace("https://", "")
    // console.log('url_part', url_part)
    // const fileName = protocolFile.split("/").pop()
    // console.log('fileNam in chatwithbot', fileName)

    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)
    // myHeaders.append("Authorization", "Bearer " + tokenResponse.accessToken);

    var raw = JSON.stringify({
        // "input_path": protocolFile,
        document_id: document_id,
        question: question,
        chat_history: chatHistory,
        folder_name: folder_name,
    })

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return (
        fetch(`${apiBaseUrl}/chat-with-input-doc`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                return result['response']
            })
            // .then(result => console.log(result))
            .catch((error) => console.log('error', error))
    )
    // await delay(2000);
}

// may need to make extra collection for output chunks for this
export const createOutputVectorstore = async (
    document_id,
    container_name,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('creating output vector store!')

    const raw = JSON.stringify({
        document_id: document_id,
        // input_container: container_name,
        input_container: 'output',
        document_type: 'testing',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    await fetch(`${apiBaseUrl}/create-output-vectorstore`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error))
}

// export const handleMultipleFiles = (files, fileContents, setMultipleFileList, setMultipleFileNameList, setMultipleFileContentList) => {
//     try {
//       // Handle saving the file content or any other logic as needed for each file
//       const newFiles = [];
//       console.log('files here', files)

//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
//         const content = fileContents[i];
//         newFiles.push({ name: file.name, content });
//         console.log('newFiles', newFiles)
//       }

//       // Update React state with the array of file objects
//       setMultipleFileList(newFiles);
//       setMultipleFileNameList(newFiles.map((file) => file.name));
//       setMultipleFileContentList(fileContents);
//     } catch (e) {
//       console.log('Error in handling files', e);
//     }
//   };

export const regenerateSection = async (
    document_id,
    sections,
    additional_info,
    files,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
        sections: sections,
        additional_info: additional_info,
        input_path: files,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    await fetch(`${apiBaseUrl}/api/regenerateSection`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error))
}

export const createNewDocumentSet = async (documentSet, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_set_name: documentSet,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/create-new-document-set`,
            requestOptions
        )
        const result = await response.text()
        console.log(result)

        return result // Return the result here
    } catch (error) {
        console.error(error)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const listAllFiles = async (container_name, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)
    myHeaders.append('Content-Type', 'application/json')

    console.log('container_name in listAllFiles:', container_name)

    const raw = JSON.stringify({
        container: container_name,
    })

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        body: raw,
        headers: myHeaders,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/list-all-files`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json() // Assuming the server returns JSON. Use .text() if it's plain text
        const files = result['files']
        // const ContainerNameWithFiles = {
        //     container_name: container_name,
        //     files: files
        // }
        return files
    } catch (error) {
        console.error(error)
        throw error // Rethrow to allow caller to handle
    }
}

export const handleMultipleFiles = (files, fileContents) => {
    try {
        const newFiles = []
        const fileNameList = []
        const fileContentList = []

        for (let i = 0; i < files.length; i++) {
            const file = files[i]
            const content = fileContents[i]
            newFiles.push({ name: file.name, content })
            fileNameList.push(file.name)
            fileContentList.push(content)
        }

        // Return an object containing the three lists
        return {
            multipleFileList: newFiles,
            multipleFileNameList: fileNameList,
            multipleFileContentList: fileContentList,
        }
    } catch (e) {
        console.log('Error in handling files', e)
        // Return null or an empty object to indicate failure
        return null
    }
}

export const processTemplate = async (
    setLoading,
    setError,
    template_file_name,
    document_type,
    template_nickname,
    description,
    orgAccessToken
) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('orgAccessToken: ', orgAccessToken.accessToken)

    const raw = JSON.stringify({
        template_file_name,
        document_type,
        template_nickname,
        description: description || '',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/process-template`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text() // Assuming the server returns JSON. Use .text() if it's plain text
        return result // This will be the value of all blobs
    } catch (error) {
        console.error(error)
        throw error // Rethrow to allow caller to handle
    }
}

export const ingestTemplateTables = async (
    template_name,
    document_nickname,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        template_name,
        document_nickname,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/ingest-template-tables`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error ingesting template tables:', error)
        throw error
    }
}

export const ingestFilledTables = async (
    document_id,
    folder,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        'document_id':document_id,
        'folder_name':folder,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/ingest-filled-tables`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error ingesting template tables:', error)
        throw error
    }
}

export const combinedCreateNewDocument = async (
    files,
    document_name,
    product_name,
    document_type,
    template_file_name,
    outline,
    document_set,
    orgAccessToken,
    rules,
    extract
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_paths: files,
        input_container: 'input',
        output_document_name: document_name,
        output_document_type: template_file_name,
        document_set_name: document_set,
        product_name: product_name,
        outline: outline,
        example: '',
        example_document: '',
        extract: extract,
        input_documents: files,
        user_rules: rules,
        model_name: 'Claude-3.5-Sonnett',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/initial-document-generation`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()

        return result
    } catch (error) {
        console.error('Error creating new document:', error)
        throw error
    }
}

export const getTemplateTypes = async (orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-template-types`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const templateTypes = result['template_types'].map(
            (template, index) => ({
                id: uuidv4(),
                document_type: template.document_type,
                template_file_name: template.template_file_name,
                description: template.description,
                document_nickname: template.document_nickname,
            })
        )
        return templateTypes
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const getOutlineFromTemplates = async (
    template_file_name,
    document_nickname,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        template_file_name: template_file_name,
        document_nickname: document_nickname,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-outline-from-template`,
            requestOptions
        )
        if (!response.ok) {
            console.log(response)
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()

        const outline = result['outline']

        const sections = outline
            .split('\n')
            .filter((section) => section.trim() !== '')

        const outlineSections = sections.map((section) => ({
            sectionName: section.trim(),
            active: true,
        }))

        return outlineSections
    } catch (error) {
        console.error('Error getting outline from template:', error)
        throw error
    }
}

export const getOutlineFromSource = async (documentId, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: documentId,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/getOneDocument`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const sections = result
            .split('\n')
            .filter((section) => section.trim() !== '')

        const outlineSections = sections.map((section) => ({
            sectionName: section.trim(),
            active: true,
        }))
        return outlineSections
    } catch (error) {
        console.error('Error fetching document outline:', error)
        throw error
    }
}

export const listAllTemplates = async (orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/list-all-templates`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json() // Assuming the server returns JSON. Use .text() if it's plain text
        const templates = result['templates']
        return templates // This will be the value of all blobs
    } catch (error) {
        console.error(error)
        throw error // Rethrow to allow caller to handle
    }
}

export const uploadEditedFile = async (
    setLoading,
    files,
    filesContent,
    setError,
    id,
    orgAccessToken
) => {
    setLoading(true)
    // const myHeaders = new Headers()
    // myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    // console.log('filesContent', filesContent)

    try {
        // Use Promise.all to upload multiple files concurrently
        const uploadPromises = files.map(async (file, i) => {
            console.log('file here', filesContent[i])
            const formData = new FormData()
            formData.append('file_name', file.name)
            formData.append('file_content', new Blob([filesContent[i]]))

            var headers = new Headers()
            headers.append('id', id)
            headers.append("Authorization", "Bearer " + orgAccessToken.accessToken);

            // headers.append('X-MS-CLIENT-PRINCIPAL-ID', '050e6292-662f-4b0f-9a89-4b0beca8bed6')

            const requestOptions = {
                method: 'POST',
                body: formData,
                headers: headers,
            }

            const response = await fetch(
                `${apiBaseUrl}/upload-edited-document`,
                requestOptions
            )

            if (!response.ok) {
                throw new Error(
                    `Error uploading file ${file.name}: ${response.statusText}`
                )
            }

            const result = await response.text()

            console.log('file name:', result)
        })

        await Promise.all(uploadPromises)
        // await delay(2000);

        setLoading(false)

        // Handle the response from the Azure Function if needed
    } catch (error) {
        console.error('Error uploading files:', error)
        setError(true)
        setLoading(false)
    }
}

export const generateAbbreviations = async (document_id, orgAccessToken) => {
    console.log('generating abbreviations')

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/generate-abbreviations`,
            requestOptions
        )
        const result = await response.text()
        return result
    } catch (error) {
        console.error(error)
    }
}

export const createMod26PKTable = async (
    input_path,
    input_container,
    template_document_type,
    document_name
) => {
    console.log('creating mod26pk table')

    console.log('Request Body:', {
        files: input_path,
        document_name: document_name,
        input_container: input_container,
        template_document_type: template_document_type,
    })

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
        input_path: input_path,
        input_container: input_container,
        template_name: template_document_type,
        document_name: document_name,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    fetch(`${apiBaseUrl}/api/combinedMod26PKTable`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error))
}

export const emailTrigger = async () => {
    const requestOptions = {
        method: 'GET',
        redirect: 'follow',
    }

    fetch(`${apiBaseUrl}/api/emailTrigger`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error))
}

export const getOneTemplate = async (template_name, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        template_file_name: template_name,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-one-template`,
            requestOptions
        )
        const result = await response.json()
        return result // Return the result here
    } catch (error) {
        console.error(error)
        throw error // Rethrow the error after logging and setting error state
    }
}

export const reCreateINDModule2Section = async (payload, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/reCreateINDModule2Section`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        console.log(result)
        return result
    } catch (error) {
        console.error('Error recreating section:', error)
        throw error
    }
}

export const reCreateINDModule2Selection = async (payload, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/recreate-selection`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const responseText = result['response']
        return responseText
    } catch (error) {
        console.error('Error recreating section:', error)
        throw error
    }
}
export const savePrompts = async (
    setLoading,
    setError,
    documentId,
    sectionInfo,
    orgAccessToken
) => {
    // setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('sectionInfo in savePrompts', sectionInfo)

    const raw = JSON.stringify({
        document_id: documentId,
        section_info: sectionInfo,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/savePrompts`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        console.log('saved prompts', result)
        return result
    } catch (error) {
        console.error(error)
        setError(true)
        throw error
    } finally {
        // setLoading(false)
    }
}

export const getHardCodedDoc = async (docType, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_type: docType,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/getHardCodedDocs`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error fetching hard-coded document:', error)
        return null
    }
}

export const getStoredTableTitles = async (
    doc_id,
    // table_type,
    // population,
    // return_multiple,
    // organization,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        // database_name: 'generalMainData',
        // container_name: 'tables',
        document_id: doc_id,
        // table_type_value: table_type,
        // population_value: population,
        // return_multiple: return_multiple,
        // organization: organization,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-stored-table-titles`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const table_titles = result['table_title_items']
        return table_titles
    } catch (error) {
        console.error('Error fetching stored table titles:', error)
        throw error
    }
}

export const extractAndStoreTFLTables = async (
    csvKey,
    csvContainer,
    csvOutputContainer,
    documentType,
    documentId,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        csv_key: csvKey,
        // csv_container: csvContainer,
        csv_output_container: csvOutputContainer,
        document_type: documentType,
        document_id: documentId,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/extract-and-store-TFL-tables`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        return await response.text()
    } catch (error) {
        console.error('Error extracting and storing TFL tables:', error)
        throw error
    }
}

export const getAnalytesFromDocument = async (documentList, orgAccessToken) => {
    console.log('getting analytes from document')

    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        doc_name: documentList[0], // Assuming we're only handling one document for now
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/getAnalytesFromDocument`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        return result
    } catch (error) {
        console.error('Error fetching analytes:', error)
        throw error
    }
}

export const generate265Tables = async (payload, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    console.log('Payload:', payload)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/generateMod265FullPkTables`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        console.log(result)
        return result
    } catch (error) {
        console.error('Error generating 2.6.5 tables:', error)
        throw error
    }
}

export const extractAndVectorizePKTables = async (file, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_path: [file],
        input_container: 'input',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/extractAndVectorizePKTables`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const statusQueryGetUri = result.statusQueryGetUri

        console.log(`Status Query URI: ${statusQueryGetUri}`)

        // Polling function to check the status
        const checkStatus = async () => {
            return new Promise((resolve, reject) => {
                const poll = async () => {
                    try {
                        const statusResponse = await fetch(statusQueryGetUri)
                        const statusResult = await statusResponse.json()

                        if (statusResult.runtimeStatus === 'Completed') {
                            console.log('Function completed:', statusResult)
                            resolve(statusResult)
                        } else if (statusResult.runtimeStatus === 'Failed') {
                            reject(
                                new Error(
                                    'Function failed: ' +
                                        JSON.stringify(statusResult)
                                )
                            )
                        } else {
                            console.log(
                                'Function not completed yet. Checking again in 1 minute...'
                            )
                            setTimeout(poll, 60000) // Check again in 1 minute
                        }
                    } catch (error) {
                        reject(error)
                    }
                }

                poll()
            })
        }

        // Start polling and wait for completion
        const statusQueryResult = await checkStatus()
        return statusQueryResult
    } catch (error) {
        console.error('Error:', error)
        throw error
    }
}

export const uploadPKFile = async (file, orgId, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const formData = new FormData()
    formData.append('file', file)

    // Include orgId in the filename
    const orgSpecificFileName = `${orgId}/${file.name}`
    formData.append('file_name', orgSpecificFileName)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/uploadPKFile`,
            requestOptions
        )

        if (!response.ok) {
            throw new Error(`Error uploading file: ${response.statusText}`)
        }

        const result = await response.text()
        console.log('File uploaded successfully:', result)
        return orgSpecificFileName // Return the filename used in blob storage
    } catch (error) {
        console.error('Error uploading PK file:', error)
        throw error
    }
}

export const saveRuleset = async (ruleset, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        ruleset: ruleset,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/save-rulesets`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        return result
    } catch (error) {
        console.error('Error saving ruleset:', error)
        throw error
    }
}

export const getAllRulesets = async (orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: myHeaders,
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/get-all-rulesets`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const rulesets = result['rulesets']
        return rulesets
    } catch (error) {
        console.error('Error fetching rulesets:', error)
        throw error
    }
}

export const extractContentPlan = (documentName, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        content_plan_key: documentName,
        input_container: 'intermediate',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(`${apiBaseUrl}/extract-content-plan`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            console.log('Content plan extracted:', result['content_plan_info'])
            return result['content_plan_info']
        })
        .catch((error) =>
            console.error('Error extracting content plan:', error)
        )
}

export const revertVersion = async (documentId, orgAccessToken) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: documentId,
        container_name: 'output',
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(`${apiBaseUrl}/api/revertVersions`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.error('Error reverting section:', error))
}

export const getJWTToken = async (orgAccessToken, payload) => {
    const myHeaders = new Headers()
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
        payload: payload,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/api/generateJWT`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        return result
    } catch (error) {
        console.error('Error fetching JWT token:', error)
        throw error
    }
}

export const generateDocumentId = async (orgAccessToken, payload) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    // Add model_name to the payload
    const requestPayload = {
        ...payload,
        model_name: 'Claude-3.5-Sonnett',
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(requestPayload),
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/generate-document-id`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        return result.document_id
    } catch (error) {
        console.error('Error generating document ID:', error)
        throw error
    }
}

export const initialDocumentGeneration = async (
    files,
    document_name,
    product_name,
    document_type,
    template_file_name,
    template_nickname,
    outline,
    document_set,
    orgAccessToken,
    rules,
    extract,
    document_id,
    output_folder
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        input_paths: files,
        output_document_name: document_name,
        output_document_type: template_file_name,
        document_set_name: document_set,
        product_name: product_name,
        outline: outline,
        extract: extract,
        input_documents: files,
        model_name: 'Claude-3.5-Sonnett',
        user_rules: rules || [],
        folder_name: output_folder,
        document_id: document_id,
        template_nickname: template_nickname,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/initial-document-generation`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        return result
    } catch (error) {
        console.error('Error in initial document generation:', error)
        throw error
    }
}

export const checkDocFolder = async (orgAccessToken, document_id) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(`${apiBaseUrl}/get-doc-folder`, requestOptions)
        .then((response) => {
            const result = response.json()
            console.log('Document folder:', result)
            return result
        })
        .catch((error) =>
            console.error('Error checking document folder:', error)
        )
}

export const move_doc_to_folder = async (
    orgAccessToken,
    document_id,
    initial_folder,
    new_folder
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
        initial_folder: initial_folder,
        new_folder: new_folder,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(`${apiBaseUrl}/move-doc-to-folder`, requestOptions)
        .then((response) => response.json())
        .catch((error) =>
            console.error('Error moving document to folder:', error)
        )
}

export const getTemplateTablesAndAssignments = async (
    orgAccessToken,
    templateId
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        template_id: templateId,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(
        `${apiBaseUrl}/get-template-tables-and-assignments`,
        requestOptions
    )
        .then((response) => response.json())
        .catch((error) =>
            console.error(
                'Error getting template tables and assignments:',
                error
            )
        )
}

export const get_extracted_tables_from_doc = async (
    orgAccessToken,
    document_id
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: document_id,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    return fetch(`${apiBaseUrl}/get-extracted-tables-from-doc`, requestOptions)
        .then((response) => response.json())
        .catch((error) =>
            console.error('Error getting extracted tables from doc:', error)
        )
}

export const fill_template_table = async (
    orgAccessToken,
    tfl_data_table_id,
    template_table_id,
    // template_id,
    document_id,
    folder_name
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        tfl_data_table_id,
        template_table_id,
        document_id,
        // template_id,
        folder_name,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/fill-template-table`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.text()
        if (result !== 'Success') {
            throw new Error(result)
        }
        return result
    } catch (error) {
        console.error('Error filling template table:', error)
        throw error
    }
}

export const recreateTable = async (payload, orgAccessToken) => {
    try {
        const response = await fetch(`${apiBaseUrl}/recreate-table`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${orgAccessToken.accessToken}`,
            },
            body: JSON.stringify(payload),
        })

        if (!response.ok) {
            throw new Error('Failed to recreate table')
        }

        const data = await response.json()
        return data
    } catch (error) {
        console.error('Error recreating table:', error)
        throw error
    }
}

export const recreateWholeDocument = async (
    documentId,
    additionalInfo,
    newSources,
    selection,
    folder,
    orgAccessToken
) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        document_id: documentId,
        additional_info: additionalInfo,
        new_sources: newSources,
        selection: selection,
        folder_name: folder,
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    }

    try {
        const response = await fetch(
            `${apiBaseUrl}/recreate-document`,
            requestOptions
        )
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const result = await response.json()
        const snippets = result['revised_snippets']
        return snippets
    } catch (error) {
        console.error('Error fetching rulesets:', error)
        throw error
    }
}

export const createFolder = async (newFolderName,key,orgAccessToken) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', 'Bearer ' + orgAccessToken.accessToken)

    const raw = JSON.stringify({
        "new_folder_name": newFolderName,
        "key": key
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    try {
        const response = await fetch(`${apiBaseUrl}/create-folder`, requestOptions);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error creating folder:', error);
        throw error;
    }
}

export const getOneMRTDocument = async (documentId, orgAccessToken) => {
    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + orgAccessToken.accessToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "document_id": documentId
    });

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${apiBaseUrl}/get-one-mrt-outline`, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log('result', result)
        return result;
    } catch (error) {
        console.error('Error getting one MRT outline:', error);
        throw error;
    }
}

export const removeSectionNumberFromTitle = (sectionName) => {
    if (sectionName.includes(".")) {
        const [section_title, section_number, title] = sectionName.match(/(^(?:\d+\.?)+)\s(.*)$/)
        return {
            section_title: section_title,
            section_number: section_number,
            title: title.toUpperCase()
        }
    } else {
        return {
            section_title: sectionName,
            section_number: "",
            title: sectionName.toUpperCase()
        }
    }
}

export const regenerateSelectionMRT = async(
    document_id, 
    connector_data_id, 
    source_index, 
    selected_text, 
    user_modifications, 
    folder_name, 
    orgAccessToken,
    example_table_html
) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + orgAccessToken.accessToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "document_id": document_id,
        "connector_data_ids": connector_data_id,
        "source_index": source_index,
        "selected_text": selected_text,
        "user_modifications": user_modifications,
        "folder_name": folder_name,
        "example_table_html": example_table_html
    });

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${apiBaseUrl}/documents/regenerate-section`, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error regenerating selection:', error);
        throw error;
    }
}

/**
 * Inserts mixed content (text and HTML tables) into an OnlyOffice document
 * @param {Object} connector - OnlyOffice document connector
 * @param {string} content - The content to insert (may contain HTML tables)
 * @param {Object} options - Optional configuration
 * @param {boolean} options.preserveFormatting - Whether to preserve HTML formatting (default: false)
 * @param {string} options.segmentSeparator - Separator between segments (default: '\n\n')
 * @returns {Promise<void>}
 */
export const insertMixedContent = async (connector, content, options = {}) => {
    const { preserveFormatting = false, segmentSeparator = '\n\n' } = options;
    
    // Regular expression to find HTML table sections
    const tableRegex = /<table[\s\S]*?<\/table>/gi;
    const segments = [];
    let lastIndex = 0;
    let match;
    
    // Find all table matches and create segments
    while ((match = tableRegex.exec(content)) !== null) {
        // Add text before the table (if any)
        if (match.index > lastIndex) {
            const textContent = content.substring(lastIndex, match.index).trim();
            if (textContent) {
                segments.push({
                    type: 'text',
                    content: textContent
                });
            }
        }
        
        // Add the table
        segments.push({
            type: 'html',
            content: match[0]
        });
        
        lastIndex = match.index + match[0].length;
    }
    
    // Add any remaining text after the last table
    if (lastIndex < content.length) {
        const remainingText = content.substring(lastIndex).trim();
        if (remainingText) {
            segments.push({
                type: 'text',
                content: remainingText
            });
        }
    }
    
    // If no tables found, treat entire content as text
    if (segments.length === 0 && content.trim()) {
        segments.push({
            type: 'text',
            content: content
        });
    }
    
    // Insert segments in order
    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        if (!segment.content) continue; // Skip empty segments
        
        await new Promise((resolve) => {
            if (segment.type === 'html') {
                // Use PasteHtml for table content
                connector.executeMethod('PasteHtml', [segment.content], function (result) {
                    console.log('PasteHtml result:', result);
                    resolve(result);
                });
            } else {
                // Use PasteText for regular text
                // Add separator between segments if not the last segment
                const textToInsert = i < segments.length - 1 && segments[i + 1]?.content 
                    ? segment.content + segmentSeparator 
                    : segment.content;
                
                connector.executeMethod('PasteText', [textToInsert], function (result) {
                    console.log('PasteText result:', result);
                    resolve(result);
                });
            }
        });
    }
}

export function findKeyByArrayValue(obj, targetValue) {
    return Object.keys(obj).find(key => 
        Array.isArray(obj[key]) && obj[key].includes(targetValue)
    )
}

export function getKeyAndValueFromObject(obj) {
    return Object.entries(obj).map(([key, value]) => {
        console.log("key", key)
        console.log("value", value)
        return { label: key, value: value} 
    })
}

/**
 * Captures the current formatting at the cursor position
 * @param {Object} connector - OnlyOffice document connector
 * @returns {Promise<Object>} Object containing paragraph and character properties
 */
export const captureCurrentFormatting = async (connector) => {
    console.log('captureCurrentFormatting')
    const formatting = {
        paragraph: {},
        character: {}
    };

    // Get current paragraph properties
    await new Promise((resolve) => {
        connector.executeMethod('GetCurrentParagraph', [], function(paragraph) {
            console.log('paragraph', paragraph)
            if (paragraph) {
                // Capture paragraph formatting properties
                const props = [
                    'Jc', // Justification (alignment)
                    'Spacing', // Line and paragraph spacing
                    'Ind', // Indentation
                    'ContextualSpacing',
                    'KeepLines',
                    'KeepNext',
                    'PageBreakBefore',
                    'WidowControl',
                    'Tabs',
                    'NumPr', // Numbering properties
                    'PStyle' // Paragraph style
                ];

                props.forEach(prop => {
                    if (paragraph[prop] !== undefined) {
                        console.log('paragraph[prop]', paragraph[prop])
                        formatting.paragraph[prop] = paragraph[prop];
                    }
                });
            }
            resolve();
        });
    });

    // Get current run (character) properties
    await new Promise((resolve) => {
        connector.executeMethod('GetCurrentRunProperties', [], function(runProps) {
            if (runProps) {
                // Capture character formatting properties
                const props = [
                    'Bold',
                    'Italic',
                    'Underline',
                    'Strikeout',
                    'FontFamily',
                    'FontSize',
                    'Color',
                    'VertAlign',
                    'HighLight',
                    'RStyle', // Character style
                    'Spacing',
                    'DStrikeout',
                    'Caps',
                    'SmallCaps'
                ];

                props.forEach(prop => {
                    if (runProps[prop] !== undefined) {
                        formatting.character[prop] = runProps[prop];
                    }
                });
            }
            resolve();
        });
    });

    return formatting;
};

/**
 * Applies formatting to the current selection
 * @param {Object} connector - OnlyOffice document connector
 * @param {Object} formatting - Formatting object from captureCurrentFormatting
 * @returns {Promise<void>}
 */
export const applyFormatting = async (connector, formatting) => {
    // Apply paragraph properties
    if (formatting.paragraph && Object.keys(formatting.paragraph).length > 0) {
        await new Promise((resolve) => {
            connector.executeMethod('SetParagraphProperties', [formatting.paragraph], function(result) {
                console.log('Applied paragraph properties:', result);
                resolve();
            });
        });
    }

    // Apply character properties
    if (formatting.character && Object.keys(formatting.character).length > 0) {
        await new Promise((resolve) => {
            connector.executeMethod('SetTextProperties', [formatting.character], function(result) {
                console.log('Applied character properties:', result);
                resolve();
            });
        });
    }
};

/**
 * Inserts mixed content (text and HTML tables) into an OnlyOffice document while preserving formatting
 * @param {Object} connector - OnlyOffice document connector
 * @param {string} content - The content to insert (may contain HTML tables)
 * @param {Object} options - Optional configuration
 * @param {boolean} options.preserveFormatting - Whether to preserve document formatting (default: true)
 * @param {string} options.segmentSeparator - Separator between segments (default: '\n\n')
 * @param {Object} options.capturedFormatting - Pre-captured formatting to apply
 * @returns {Promise<void>}
 */
export const insertMixedContentWithFormatting = async (
    connector, 
    content,
    segmentSeparator='\n\n'
) => {
    // Regular expression to find HTML table sections
    const tableRegex = /<table[\s\S]*?<\/table>/gi;
    const segments = [];
    let lastIndex = 0;
    let match;
    
    // Find all table matches and create segments
    while ((match = tableRegex.exec(content)) !== null) {
        // Add text before the table (if any)
        if (match.index > lastIndex) {
            const textContent = content.substring(lastIndex, match.index).trim();
            if (textContent) {
                segments.push({
                    type: 'text',
                    content: textContent
                });
            }
        }
        
        // Add the table with style preservation
        let tableHtml = match[0];
        
        segments.push({
            type: 'html',
            content: tableHtml
        });
        
        lastIndex = match.index + match[0].length;
    }
    
    // Add any remaining text after the last table
    if (lastIndex < content.length) {
        const remainingText = content.substring(lastIndex).trim();
        if (remainingText) {
            segments.push({
                type: 'text',
                content: remainingText
            });
        }
    }
    
    // If no tables found, treat entire content as text
    if (segments.length === 0 && content.trim()) {
        segments.push({
            type: 'text',
            content: content
        });
    }
    
    // Insert segments in order
    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        if (!segment.content) continue; // Skip empty segments
        
        await new Promise((resolve) => {
            if (segment.type === 'html') {
                // Use PasteHtml for table content
                connector.executeMethod('PasteHtml', [segment.content], function (result) {
                    console.log('PasteHtml result:', result);
                    resolve(result);
                });
            } else {
                // Use PasteText for regular text
                const textToInsert = i < segments.length - 1 && segments[i + 1]?.content 
                    ? segment.content + segmentSeparator 
                    : segment.content;
                
                connector.executeMethod('PasteText', [textToInsert], function (result) {
                    console.log('PasteText result:', result);
                    resolve(result);
                });
            }
        });
    }
};

/**
 * Detects the context of the current cursor position (table title, footnote, normal text)
 * @param {Object} connector - OnlyOffice document connector
 * @returns {Promise<string>} Context type: 'table-title', 'footnote', 'normal'
 */
export const detectDocumentContext = async (connector) => {
    let context = 'normal';
    
    // Check if we're in a footnote
    await new Promise((resolve) => {
        connector.executeMethod('GetCurrentFootnote', [], function(footnote) {
            if (footnote) {
                context = 'footnote';
            }
            resolve();
        });
    });
    
    // If not in footnote, check paragraph style for table titles
    if (context === 'normal') {
        await new Promise((resolve) => {
            connector.executeMethod('GetCurrentParagraph', [], function(paragraph) {
                if (paragraph && paragraph.PStyle) {
                    const style = paragraph.PStyle.toLowerCase();
                    if (style.includes('table') && (style.includes('title') || style.includes('caption'))) {
                        context = 'table-title';
                    }
                }
                resolve();
            });
        });
    }
    
    return context;
};

/**
 * Applies context-aware formatting based on document location
 * @param {Object} connector - OnlyOffice document connector
 * @param {Object} baseFormatting - Base formatting captured from the document
 * @param {string} context - Document context ('table-title', 'footnote', 'normal')
 * @returns {Object} Modified formatting object
 */
export const getContextAwareFormatting = (baseFormatting, context) => {
    const formatting = JSON.parse(JSON.stringify(baseFormatting)); // Deep copy
    
    switch (context) {
        case 'table-title':
            // Table titles typically use specific formatting
            if (!formatting.paragraph.Jc) {
                formatting.paragraph.Jc = 'center'; // Center alignment
            }
            if (!formatting.character.Bold) {
                formatting.character.Bold = true; // Bold text
            }
            // Preserve any existing table caption style
            if (!formatting.paragraph.PStyle || !formatting.paragraph.PStyle.includes('caption')) {
                formatting.paragraph.PStyle = 'Caption';
            }
            break;
            
        case 'footnote':
            // Footnotes typically use smaller font size
            if (formatting.character.FontSize && formatting.character.FontSize > 10) {
                formatting.character.FontSize = Math.max(8, formatting.character.FontSize - 2);
            }
            // Ensure footnote style is applied
            if (!formatting.paragraph.PStyle || !formatting.paragraph.PStyle.includes('footnote')) {
                formatting.paragraph.PStyle = 'Footnote';
            }
            break;
            
        case 'normal':
            // Normal text keeps the captured formatting
            // No modifications needed
            break;
    }
    
    return formatting;
};

/**
 * Enhanced regeneration function with context-aware formatting
 * @param {Object} connector - OnlyOffice document connector
 * @param {string} content - Content to insert
 * @param {Object} options - Configuration options
 * @returns {Promise<void>}
 */
export const insertContentWithContextualFormatting = async (connector, content, options = {}) => {
    const {
        preserveFormatting = true,
        autoDetectContext = true,
        forceContext = null, // 'table-title', 'footnote', 'normal'
        segmentSeparator = '\n\n'
    } = options;
    
    // Detect or use forced context
    const context = forceContext || (autoDetectContext ? await detectDocumentContext(connector) : 'normal');
    console.log('Detected document context:', context);
    
    // Capture base formatting
    const baseFormatting = await captureCurrentFormatting(connector);
    
    // Apply context-aware modifications
    const contextualFormatting = getContextAwareFormatting(baseFormatting, context);
    
    // Insert content with the contextual formatting
    await insertMixedContentWithFormatting(connector, content, {
        preserveFormatting: true,
        capturedFormatting: contextualFormatting,
        segmentSeparator: segmentSeparator
    });
};

/**
 * Enhanced table HTML generation with style preservation
 * @param {string} tableHtml - Original table HTML
 * @param {Object} formatting - Formatting object containing styles
 * @returns {string} Enhanced table HTML with embedded styles
 */
export const enhanceTableHtmlWithStyles = (tableHtml, formatting) => {
    if (!formatting || !formatting.character) return tableHtml;
    
    // Build style string from formatting
    const styles = [];
    
    if (formatting.character.FontFamily) {
        styles.push(`font-family: ${formatting.character.FontFamily}`);
    }
    if (formatting.character.FontSize) {
        styles.push(`font-size: ${formatting.character.FontSize}pt`);
    }
    if (formatting.character.Color) {
        // Convert color object to CSS color
        const color = formatting.character.Color;
        if (color.R !== undefined && color.G !== undefined && color.B !== undefined) {
            styles.push(`color: rgb(${color.R}, ${color.G}, ${color.B})`);
        }
    }
    
    if (styles.length === 0) return tableHtml;
    
    const styleString = styles.join('; ');
    
    // Apply styles to table
    if (tableHtml.includes('style="')) {
        // Append to existing style attribute
        tableHtml = tableHtml.replace(/style="([^"]*)"/, `style="$1; ${styleString}"`);
    } else {
        // Add new style attribute
        tableHtml = tableHtml.replace('<table', `<table style="${styleString}"`);
    }
    
    // Also apply to all td and th elements for consistency
    tableHtml = tableHtml.replace(/<(td|th)([^>]*)>/gi, (match, tag, attrs) => {
        if (attrs.includes('style="')) {
            return `<${tag}${attrs.replace(/style="([^"]*)"/, `style="$1; ${styleString}"`)}>`;
        } else {
            return `<${tag}${attrs} style="${styleString}">`;
        }
    });
    
    return tableHtml;
};

export const combine = (arr1, arr2, foreignKey) => {
    const mergedObjects = {};

    // Add objects from arr1 to the temporary object
    arr1.forEach(obj => {
        if (obj[foreignKey]) {
            mergedObjects[obj[foreignKey]] = { ...obj };
        }
    });

    // Merge objects from arr2 based on the foreign key
    arr2.forEach(obj => {
        if (obj[foreignKey]) {
            mergedObjects[obj[foreignKey]] = mergedObjects[obj[foreignKey]] 
            ? { ...mergedObjects[obj[foreignKey]], ...obj } 
            : { ...obj };
        }
    });

    return Object.values(mergedObjects);
};
  
export const getAllStyleGuides = async (orgAccessToken) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + orgAccessToken.accessToken)


    const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
    };

    return fetch(`${apiBaseUrl}/list-all-style-guides`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.error(error));
    
}

export const getAllMRTTables = async (connectorDataIds, orgAccessToken) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + orgAccessToken.accessToken)
    const raw = JSON.stringify({
        "connector_data_ids": connectorDataIds
        });

    const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
    };

    return fetch(`${apiBaseUrl}/list-all-mrt-tables`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.error(error));
}

export const getAllMRTReports = async (connectorDataIds, orgAccessToken) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + orgAccessToken.accessToken)
    const raw = JSON.stringify({
        "connector_data_ids": connectorDataIds
        });
    console.log('connectorDataIds', connectorDataIds)
    console.log('raw', raw)

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return fetch(`${apiBaseUrl}/list-all-ncr-documents`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.error(error));
}